/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import { useInjectSaga } from "../../utils/injectSaga";
import { useInjectReducer } from "../../utils/injectReducer";
import reducer from "./reducer";
import saga from "./saga";
import { checkOktaSession, decodeEncData } from "./actions";
import {get, isEmpty } from "lodash";
import * as LocalStoreService from "../../LocalStoreService";
import { injectIntl } from "react-intl";
import { getOidcFromParams } from "../../utils/oidcService";
import { browserValidation } from "../FederatedDriveSSO/browserCheck";
import { useCookies } from "react-cookie";
import { samlRedirect } from "./saml";
import getFromCookie from '../../utils/cookieUtil';

export function PreLoginPage(props) {
  const dispatch = useDispatch();

  useInjectReducer({ key: "loginPage", reducer });
  useInjectSaga({ key: "loginPage", saga });

  const history = useHistory();
  const cookies = useCookies();

  const isFederatedFlow = () => {
    let params = new URLSearchParams(props.location.search);
    const appFlow = params.get("flow");
    if (appFlow && appFlow === "federation") {
      return true;
    }
    return false;
  };

  const isDccFlow = () => {
    let params = new URLSearchParams(props.location.search);
    const appFlow = params.get("flow");
    if (appFlow && appFlow === "dcc") {
      return true;
    }
    return false;
  };

  const isLogoutFlow = () => {
    let params = new URLSearchParams(props.location.search);
    const appFlow = params.get("flow");
    if (appFlow && appFlow === "logout") {
      return true;
    }
    return false;
  };

  const isCleanUpIdpFlow = () => {
    let params = new URLSearchParams(props.location.search);
    const appFlow = params.get("flow");
    const idpFlow = params.get("type");
    if (appFlow && appFlow === "cleanup" && idpFlow && idpFlow === "idp") {
      return true;
    }
    return false;
  };

  const isOidcParamsAvailable = (oidc) =>
    oidc.client_id !== null || !isEmpty(oidc.client_id);

  const getOidcParams = () => {
    let params = new URLSearchParams(props.location.search);
    let oidc = getOidcFromParams(params);

    if (isOidcParamsAvailable(oidc)) {
      LocalStoreService.setOidc(oidc);
      return true;
    }
    return false;
  };

  const getEncData = () => {  
    let encData;
    if(props.location.search && props.location.search.includes("encData=")) {
      encData = props.location.search.replace("?encData=", "");
    }
    return encData;
  };

  const isFromURIFlow = (fromURI) => {
    if (!isEmpty(fromURI)) {
      return fromURI;
    }
    return false;
  };

  const sessionToken = useSelector((state) =>
    get(state, "loginPage.authnResponse.sessionToken", "")
  );

  const showBgImage = useSelector((state) =>
    get(state, "logout.displayBackgroundImage")
  );

  const hideBackgroundImage = () => {
    if (showBgImage) {
      dispatch({
        type: "SHOW_BACKGROUND",
        data: false,
      });
    }
  };

  const routeToFedetation = () => {
    let errMsg = browserValidation();
    if (isEmpty(errMsg)) {
      history.push("/federation");
    } else {
      history.push("/error-page", { errorMessage: errMsg });
    }
  };

  const captureInStore = (key, value) => {
    if (!isEmpty(value)) {
      LocalStoreService.set(key, value);
    }
  };

  useEffect(() => {
    hideBackgroundImage();
    let params = new URLSearchParams(props.location.search);
    const fromURI = params.get("fromURI");
    const originalTarget = getFromCookie(cookies, "originalTarget");
    const logonUrl = getFromCookie(cookies, "logonUrl");
    const relayState = params.get("relayState");
    
    let samlParams = {
      logonUrl: logonUrl,
      originalTarget: originalTarget
    };
    if(!isEmpty(sessionToken) && sessionToken !== null){
      samlParams = {...samlParams, sessionToken: sessionToken};
    }
    if(!isEmpty(fromURI) && fromURI !== null){
      samlParams = {...samlParams, fromURI: fromURI};
    }
    if(!isEmpty(relayState) && relayState !== null){
      samlParams = {...samlParams, relayState: relayState};
    }

    captureInStore("samlParams", samlParams);


    const isOidcFlow = getOidcParams();
    const encDataWithLogOnUrl = getEncData();

    console.log("code version: 1.00");

    if (isFederatedFlow()) {
      console.log("PreLogin Federation flow");
      routeToFedetation();
    } 
    else if(isCleanUpIdpFlow()){
      console.log("IDP Logout flow");
      history.push("/logout-idp");
    }
    else if (isLogoutFlow()) {
      console.log("PreLogin Logout flow");
      let params = new URLSearchParams(props.location.search);
    const type = params.get("type");
      history.push("/logout?type="+type);
    }else if(encDataWithLogOnUrl){
      console.log("PreLogin encData flow");
      const decodedEncData = encDataWithLogOnUrl.split('*');
      const encData = decodedEncData[0];
      samlParams.encDataLogonUrl = decodedEncData[1];
      captureInStore("samlParams", samlParams);
      console.log(" encData flow, encData:"+encData);
      console.log(" encData flow,encodeURIComponent encData:"+encodeURIComponent(encData));
      if (!isEmpty(samlParams.encDataLogonUrl) && samlParams.encDataLogonUrl.includes(".drive.")){ // %252F -> %2F
        dispatch(decodeEncData(decodeURIComponent(encData)));
      } else {
        dispatch(decodeEncData(encodeURIComponent(encData)));
      }
    }
    else if (isOidcFlow) {
      console.log("PreLogin oidc flow");
      dispatch(checkOktaSession());
    } else if (!isFromURIFlow(fromURI) || !isEmpty(sessionToken)) {
      let url = samlRedirect(samlParams);
      console.log("saml redirecting url:", url);
      LocalStoreService.remove("samlParams");
      window.location = url;
    } 
    else{
      console.log("PreLogin Else:");
      history.push("/login");
    }
  }, [showBgImage]);

  return <div style={{margin: '10px', textColor: 'white', color: 'white'}}>Loading...</div>;
}

export default withRouter(injectIntl(PreLoginPage));
